<template>
  <div class="set-All">
    <div class="header-nav">
        <div class="logo">
          <router-link to="/home">
            <img src="../assets/images/setAimLogo.png" alt="">
          </router-link>
        </div>
      <div class="menu-btn pc_hide" id="menuBtnId" @click="menuShow()">
        <a><i></i></a>
      </div>
        <div class="nav" :class="{'mhide':!menuDataHide }">
          <a class="close-btn" id="menuCloseBtnId" @click="menuHide()"></a>
          <ul>
            <li @click="linktop('top1')" :class="[{active : refname=='top1'}]"  >成立宗旨 <em></em> </li>
            <li @click="linktop('top2')" :class="[{active : refname=='top2'}]">捐款章程 <em></em></li>
            <li @click="linktop('top3')" :class="[{active : refname=='top3'}]">最新消息 <em></em></li>
            <li @click="linktop('top4')" :class="[{active : refname=='top4'}]">辦事細則 <em></em></li>
            <li @click="linktop('top5')" :class="[{active : refname=='top5'}]">基金會概況表<em></em></li>
            <li @click="linktop('top6')" :class="[{active : refname=='top6'}]">捐款人名冊<em></em></li>
          </ul>
        </div>
    </div>
      <div class="set-banner">
        <div>
          <img src="../assets/images/SetBanner.png" alt="" class="mobile_hide">
          <img src="../assets/images/SetBannerM.png" alt="" class="pc_hide">
        </div>
        <a href="#top1" class="scrollTop mobile_hide"><div data-v-84399ace="" class="scroll-img"></div></a>
      </div>
      <div class="set-conten scrollTop" ref="top1" id="top1">
        <div class="titleBox">
          <h2 >Purpose of establishment</h2>
          <p class="subtitle ">
            <span class="line"></span>
            <span class="subtitle-font">成立宗旨</span>
          </p>
        </div>
        <div class="set-purpose-box">
            <div class="img">
              <img src="../assets/images/setPurpose.png" alt="">
            </div>
            <div class="text">
              八方雲集創辦人林家鈺自創業起，即將濟弱扶貧的理念融入企業經營，
              協助中年失業者加入八方雲集的加盟體系，透過自己的努力開創事業第二春，讓公司與加盟主共創雙贏，
              此外，創辦人與從事教育的夫人蘇老師，一直以來持續捐助偏遠地區學校與貧困孩童，對任何需要支援的團體不遺餘力，
              更於民國100年10月10日成立八方雲集社會福利慈善事業基金會，將助貧的力量更強化。
            </div>
        </div>
      </div>
    <div class="donation-box">
      <div class="donation-text">
        <div ref="top2" id="top2">
          <div class="donation-text-conten">
            <div class="titleBox titleBox2 color-white">
              <h2 >Donation chapter </h2>
              <p class="subtitle ">
                <span class="line"></span>
                <span class="subtitle-font">捐款章程</span>
              </p>
            </div>
            <div class="donation-img pc_hide">
              <img src="../assets/images/donationM.png" alt="">
            </div>
              <div class="donation-text-box">
                <p class="date">106/12/5</p>
                <p class="subtitle">財團法人新北市私立八方雲集社會福利慈善事業基金會捐助章程</p>
                <div class="account">
                  <p><label >捐款帳號：</label>167100080620 華南銀行 淡水分行</p>
                  <p><label >戶　　名：</label>財團法人新北市私立八方雲集社會福利慈善事業基金會</p>
                </div>
                <div class="send">
                  <p>匯款後麻煩請來電告知姓名住址，以便開立收據寄出。</p>
                  <p>(02)8809-8898#8874 許小姐</p>
                </div>
                <div class="btnButton">
                  <a href="../../static/files/八方雲集捐款章程.pdf" download="">章程下載</a>
                </div>
              </div>
          </div>
          <div class="donation-img mobile_hide">
            <img src="../assets/images/donation.png" alt="" >
          </div>
        </div>
        <div class="news-all"  ref="top3" id="top3">
          <div class="titleBox titleBox2 text-right color-white">
            <h2 >Latest News</h2>
            <p class="subtitle ">
              <span class="line"></span>
              <span class="subtitle-font">最新消息	</span>
            </p>
          </div>
          <div class="news-text hide_768">
            <div class="scrlloBar">
              <ul>
                <li v-for="(item,index) in newList" :key="index">
                  <div class="img">
                    <img :src="item.image" alt="">
                  </div>
                  <div class="text">
                    <div class="conten">
                      <h3>{{item.title}}</h3>
                      <p>{{item.description}}</p>
                    </div>

                  </div>
                  <div class="more">
                    <router-link :to="'/setAimDetails/'+item.id">更多內容</router-link>
                    <em></em>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="show_768 setNews-swiper">
            <div class="swiper-container setNews-all" >
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in newList" :key="index">
                  <div class="swiper-box">
                    <router-link :to="'/setAimDetails/'+item.id">
                      <div class="img">
                        <img :src="item.image" alt="">
                      </div>
                      <div class="text">
                        <div class="conten">
                          <h3>{{item.title}}</h3>
                          <p>{{item.description}}</p>
                        </div>
                      </div>
                    </router-link>
                  </div>

                </div>
              </div>
              <div class="swiper-button-next swiper-button-next-set"></div>
              <div class="swiper-button-prev swiper-button-prev-set"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="service-rules"  ref="top4" id="top4">
      <div class="titleBox titleBox2 titleBox2-C text-C">
        <h2 >Service rules</h2>
        <p class="subtitle ">
          <span class="line pc_hide "></span>
          <span class="subtitle-font">辦事細則</span>
          <span class="line  mobile_hide"></span>
        </p>
        <p class="subtitle-2">（第一屆第一次董事會會議通過後執行）</p>
      </div>
      <div class="service-swiper ">
        <div class="service-conten-90">
          <div class="swiper-container swiper-serviceBox">
            <div class="swiper-wrapper">
              <div class="swiper-slide" >
                <div class="slide-box">
                  <p class="title">01</p>
                  <p class="text">
                    本辦事細則依據財團法人新北市私立八方雲集社會福利慈善事業基金會（以下簡稱本會）成立宗旨訂定。
                  </p>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide-box">
                  <p class="title">02</p>
                  <p class="text">
                    為順利推展本會會務工作，本會設執行長、會計及出納各一人，由董事會遴選。
                  </p>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide-box">
                  <p class="title">03</p>
                  <p class="text">
                    執行長、會計及出納受董事會之指導監督，協助本會處理會務，為無給職，任期與當屆董事同。
                  </p>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide-box">
                  <p class="title">04</p>
                  <p class="text">
                    本會印鑑由執行長保管，存摺由出納保管，定期存單由董事長保管。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="swiper-button-next  swiper-button-next-service"></div>
        <div class="swiper-button-prev swiper-button-prev-service"></div>
      </div>
    </div>
    <div class="personnel-all">
  <!--    <div class="titleBox text-C pc_hide">
        <h2 >About us</h2>
        <p class="subtitle ">
          <span class="line pc_hide "></span>
          <span class="subtitle-font">基金會概況表</span>
          <span class="line  mobile_hide"></span>
        </p>
        <p class="subtitle-2">第一屆第一次董事會會議通過後執行）</p>
      </div>-->
      <div class="personnel-box">
        <div class="personnel-box-top" ref="top5" id="top5">
          <div class="titleBox titleBox2 titleBox2-C" >
            <h2 >About us</h2>
            <p class="subtitle ">
              <span class="line pc_hide "></span>
              <span class="subtitle-font">基金會概況表</span>
              <span class="line  mobile_hide"></span>

            </p>
          </div>
          <div class="personnel-list-name">
            <ul>
              <li>
                <span class="name">名稱</span>
                <span class="text">財團法人新北市私立八方雲集社會福利慈善事業基金會</span>
              </li>
              <li>
                <span class="name">設立地點</span>
                <span class="text">新北市淡水區中正東路2段27之3號18樓</span>
              </li>
              <li>
                <span class="name">目的事業</span>
                <span class="text">辦理老人、婦女兒童、身心障礙者、低收入戶、貧困家庭、老弱無依者、清寒學生等社會福利慈善事業</span>
              </li>
              <li>
                <span class="name">基金規模</span>
                <span class="text">新台幣壹仟萬元</span>
              </li>
              <li>
                <span class="name">服務對象</span>
                <span class="text">老人、婦女、兒童、身心障礙者、低收入戶、貧困家庭、老弱無依者、清寒學生等</span>
              </li>
              <li>
                <span class="name">創辦日期及創辦人</span>
                <span class="text">創辦日期：中華民國100年10月10日　創辦人：林家鈺</span>
              </li>
              <li>
                <span class="name">董事會(第四屆) </span>
                <span class="text">本基金會設置董事七人，董事長：蘇淑幸，董事成員：蘇淑幸/林宜臻/張瑞蓮/黃婉玲/袁建民/林御政/蕭慧吟</span>
              </li>
              <li>
                <span class="name">行政組織</span>
                <span class="text">董事會→董事長→執行長→業務組、財務組</span>
              </li>
              <li>
                <span class="name">會務工作人員</span>
                <span class="text">執行長：蕭慧吟，出納：吳淑惠，會計：許敏馨</span>
              </li>
            </ul>
          </div>
        </div>


      </div>
    </div>
    <div class="setAboutUs">

      <div class="donor-roster" >
        <div class="titleBox titleBox2 titleBox2-C color-white text-C" ref="top6" id="top6">
          <h2 >Donor roster </h2>
          <p class="subtitle ">
            <span class="line pc_hide "></span>
            <span class="subtitle-font">捐款人名冊</span>
            <span class="line  mobile_hide"></span>
          </p>
        </div>
        <div class="donor-swiper">
          <div class="donor-conten-90">
            <div class="swiper-container swiper-donorBox">
              <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item2,index2) in DonorList" :key="index2">
                    <div class="img-box">
                      <a :href="item2.documentPath" target="_blank" >
                        <div class="img">
                          <img :src="item2.image" alt="">
                          <div class="number">
                            {{item2.year}}
                          </div>
                        </div>
                        <div class="text">
                          <p>{{item2.year}} 年度</p>
                          <p>{{item2.documentName}}</p>
                        </div>
                      </a>

                    </div>
                  </div>

              </div>
            </div>
          </div>

          <div class="swiper-button-next swiper-button-next2"></div>
          <div class="swiper-button-prev swiper-button-prev2"></div>
        </div>
      </div>
    </div>
    <div class="setFoot">
      <div>
        <p>Copyright 2022 © 八方雲集國際股份有限公司 All Rights Reserved </p>
      </div>

    </div>
  </div>
</template>
<script>
  import API from "./config/api";
  export default {
    name: 'SetAim',
    data () {
      return {
        newList:{},
        DonorList:{},
        refname:'top1',
        menuDataHide:false
      }
    },
    mounted () {
      if(this.$route.query.id){
        this.linktop(this.$route.query.id)
      };
      this.GetnewList();
      this.GetDonor();
      //滚动监听事件
      this.$nextTick(()=>{
        let self = this;
        setTimeout(()=>{
          let myHeightAtrr = [];
          let heightAtrr = [];
          myHeightAtrr = [847,$('#top1').height(),$('#top2').height()+100,$('#top3').height()+110,$('#top4').height()-100,$('#top5').height()+100,$('#top6').height()];
          let num = myHeightAtrr[0];
          for(let i=1;i<myHeightAtrr.length;i++){
            num += myHeightAtrr[i];
            heightAtrr.push(num);
          }
          $(window).resize(function () {
            heightAtrr = [];
            myHeightAtrr = [847,$('#top1').height(),$('#top2').height()+100,$('#top3').height()+110,$('#top4').height()-100,$('#top5').height()+100,$('#top6').height()];
            num = myHeightAtrr[0];
            for(let i=1;i<myHeightAtrr.length;i++){
              num += myHeightAtrr[i];
              heightAtrr.push(num);
            }
          })
          $(window).scroll(function(){
            if($(this).scrollTop() < heightAtrr[0]){
              self.refname = 'top1';
            }else if($(this).scrollTop() >= heightAtrr[0] && $(this).scrollTop() < heightAtrr[1]){
              self.refname = 'top2';
            }else if($(this).scrollTop() >= heightAtrr[1] && $(this).scrollTop() < heightAtrr[2]){
              self.refname = 'top3';
            }else if($(this).scrollTop() >= heightAtrr[2] && $(this).scrollTop() < heightAtrr[3]){
              self.refname = 'top4';
            }else if($(this).scrollTop() >= heightAtrr[3] && $(this).scrollTop() < heightAtrr[4]){
              self.refname = 'top5';
            }else {
              self.refname = 'top6';
            }
          })
        },500)
      })

      //scroll top
      $('.scrollTop').click(function(e) {
        e.preventDefault();
        var target = $(this).attr('href');
        var targetPos = $(target).offset().top - 100;
        $('html, body').animate({ scrollTop: targetPos }, 1000);
      });
    },
    methods:{
      linktop(refid){
        this.menuDataHide=false;
        const { top } = $(`#${refid}`).offset();
        $('html , body').animate({scrollTop: top}, 'slow');
        this.refname = refid;
      },
      menuShow(){
        this.menuDataHide=true;
        $('body').addClass('no-scroll');
      },
      menuHide(){
        this.menuDataHide=false;
        $('body').removeClass('no-scroll');
      },
      GetnewList:function(){
        this.$post(API.GetWebFoundationNewList,{
          }).then((response) => {
            if(response.code === 200){
            this.newList = response.data;
            let self = this;
            this.$nextTick(()=>{
              self.serviceSwiper();
            })
          }
        });
      },
      GetDonor:function(){
        this.$post(API.GetWebFoundationDonorList,{
          }).then((response) => {
            if(response.code === 200){
            this.DonorList = response.data;
            let self = this;
            this.$nextTick(()=>{
              self.donorSwiper();
            })
          }
        });
      },

      serviceSwiper(){
        var swiper = new Swiper('.swiper-serviceBox', {
          uniqueNavElements: false,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next-service',
            prevEl: '.swiper-button-prev-service',
          },
          breakpoints: {
            768: {  //当屏幕宽度大于等于768
              slidesPerView: 1,
            },
            1280: {  //当屏幕宽度大于等于1280
              spaceBetween: 26,
              slidesPerView: 4,
            }
          }
        });

        const newsSwiper = new Swiper('.setNews-all', {
          uniqueNavElements: false,
          slidesPerView: 1,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next-set',
            prevEl: '.swiper-button-prev-set',
          },
        });
      },
      donorSwiper(){
        var swiper = new Swiper('.swiper-donorBox', {
          uniqueNavElements: false,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next2',
            prevEl: '.swiper-button-prev2',
          },
          breakpoints: {
            768: {  //当屏幕宽度大于等于768
              slidesPerView: 1,
              spaceBetween:0,
            },
            1280: {  //当屏幕宽度大于等于1280
              slidesPerView: 4,
              spaceBetween:40,
            }
          }
        });
      },

    }
  }
</script>


<style scoped lang="scss">
.show_768{
  display: none;
}
.scrlloBar {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.scrlloBar::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.scrlloBar::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #F2F2F2;
}

.scrlloBar::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}


.set-All {
  width: 100%;
  height: auto;
  background: #FAFAFA;

  .set-banner {
    width: 100%;
    max-height: 847px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      background-size: cover;
    }
    .scroll-img{
      width:30px;
      height:94px;
      background: url(../assets/images/scroll.png) no-repeat;
      position: absolute;
      left: 90px;
      bottom: 68px;
      z-index: 1;
      background-size: 100%;
    }
  }

  .set-conten {
    max-width: 1417px;
    height: auto;
    margin-left: 240px;
    padding-top: 123px;
    padding-bottom: 188px;

    .titleBox {
      width: 100%;
      height: auto;
      text-align: center;
      padding-bottom: 72px;

    }

    .set-purpose-box {
      width: 100%;
      height: auto;
      position: relative;

      .img {
        max-width: 1150px;
        height: 614px;

        img {
          width: 100%;
          height: 100%;
          background-size: 100%;
          border: 8px solid #fff;
          border-radius: 20px;
        }
      }

      .text {
        height: auto;
        max-width: 656px;
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);
        padding:59px 85px 54px 85px;
        color: #342112;
        font-size: 20px;
        letter-spacing: 1px;
        line-height: 36px;
        text-align: justify;
        position: absolute;
        bottom: -12%;
        right: 0;
      }
    }
  }

  .donation-box {
    width: 100%;
    height: auto;
    background: url(../assets/images/donationBg.png) no-repeat center top;
    /*background-size: 100%;*/
    .donation-text {
      max-width: 1630px;
      height: auto;
      margin-left: 240px;
      padding-top: 100px;
    }
    #top2{
      padding-top:100px;
    }
    .donation-text-conten {
      height: auto;
      width: 45%;
      display: inline-block;

      .donation-text-box {
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);
        padding: 40px 46px;
      }

      .date {
        color: #261A16;
        font-size: 24px;
        font-style: italic;
        font-weight: 900;
        text-align: justify;
        letter-spacing: 1.33px;
      }

      .subtitle {
        color: #261A16;
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 36px;
      }

      .account {
        padding-top: 23px;
        border-bottom: 1px solid #F3F3F3;

        p {
          color: #261A16;
          font-size: 20px;
          text-align: justify;
          letter-spacing: 1px;

          &:last-child{
           padding-bottom:26px;
           }
        }
      }

      .send {
        padding: 32px 0;

        p {
          color: #261A16;
          font-size: 16px;
          text-align: justify;
          padding-bottom: 16px;
            &:last-child{
               padding-bottom:6px;
             }
        }
      }
    }

    .donation-img {
      width: 53%;
      height: auto;
      display: inline-block;
      vertical-align: top;

      img {
        width: 100%;
        height: 100%;
        background-size: 100%;
        margin-left: 3%;

      }

      &.pc_hide {
        display: none;
      }
    }
  }
}

.titleBox2 {
  margin-left: 0;
  margin-bottom: 80px;
  padding-top: 0;
}
#top6{
  padding-top: 100px;
}

.news-all {
  max-width: 1440px;
  height: auto;
  padding-top: 100px;
  .news-text {
    width: 100%;
    height: 620px;
    border-radius: 20px;
    background-color: #FFFFFF;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);
    padding: 60px 74px;
    padding-right: 16px;
    margin-top:122px;
    ul {
      margin-right: 50px;
      padding-left:0;
      li {
        width: 100%;
        height: auto;
        padding: 20px 0;
        border-bottom: 1px solid #F3F3F3;
        position: relative;
        .img {
          width: 186px;
          margin-right: 43px;
          height: 140px;
          display: inline-block;
          vertical-align: top;
          padding-left:34px;
          img {
            width: 100%;
            height: 100%;
            background-size: 100%;
            border-radius: 22px
          }
        }

        .text {
          width: calc(100% - 288px);
          display: inline-block;
          position: relative;
          padding-top:20px;
          .conten {
            width: 85%;
            h3 {
              font-size: 22px;
              font-weight: 500;
              letter-spacing: 1px;
              margin-bottom: 0;
            }

            p {
              font-size: 18px;
              line-height: 32px;
              padding-top: 8px;
              letter-spacing: 1px;
            }
          }


        }
        .more {
          position: absolute;
          right: 33px;
          bottom:40px;
            a {
              color: #D00717;
              font-size: 16px;
        /*      background: url(../assets/images/nextPageR.svg) no-repeat -48px 15px;
              padding-bottom: 20px;
              padding-left: 0;*/
              text-align: left;
     /*         padding-right: 21px;*/
              letter-spacing: 1px;
            }
            em{
              height:15px;
              width: 130px;
              background: url(../assets/images/nextPageR.svg) no-repeat  ;
              background-size: 100%;
              display: block;
            }
        }
          &:first-child{
             padding-top: 0;
           }
          &:last-child{
             border: 0;
             padding-bottom: 0;
           }
      }
    }
  }
}

.service-rules {
  width: 90%;
  height: auto;
  margin: auto;
  padding-top:100px;
  .service-swiper {
    width: 100%;
    height: auto;
    position: relative;
    margin-top: 104px;

    .swiper-slide {
      width: 25%;
      padding-top: 80px;
      padding-bottom: 25px;

      .title {
        transform: rotate(360deg);
        font-size: 60px;
        font-style: italic;
        font-weight: 900;
        position: absolute;
        top: -40px;
        left: 28px;
        letter-spacing: -0.75px;
      }
      .text{
        color: #261A16;
        font-size: 20px;
        letter-spacing: 1px;
        line-height: 36px;
        text-align: left;
      }
      .slide-box {
        width: 100%;
        min-height: 250px;
        border-radius: 20px;
        background-color: #FFFFFF;
        padding: 54px 40px;
        position: relative;


      }
    }
  }

  .service-conten-90 {
    width: 90%;
    margin: auto;
  }

  .subtitle-2 {
    font-size: 20px;
    margin-top: 20px;
    letter-spacing: 1px;
    color: #2F1E14;
  }
  .swiper-slide{
    transition: transform .3s ease-in-out, -webkit-transform .3s ease-in-out;
  }
  .swiper-slide-active {
    transform: translateY(-40px) !important;
  }
  .swiper-slide-next{
    & + .swiper-slide{
      & + .swiper-slide{
        transform: translateY(-40px)
      }
    }
  }

  .swiper-button-next{
    height: 40px;
    right: 34px;
  }
  .swiper-button-prev{
    height: 40px;
    left: 34px;
  }
}

.setAboutUs {
  width: 100%;
  height: auto;
  background: #D00717 url(../assets/images/donationBg2.png) no-repeat center top;
  margin-top: -280px;
}

.personnel-all {
  position: relative;
  min-height: 400px;
}

.personnel-box {
  max-width:1440px;
  height: auto;
  margin-left: 240px;
  .personnel-box-top{
    padding-top: 100px;
  }
 /* position: absolute;
  left: 20%;
  top: -79px;*/
  .personnel-list-name {
    margin-top: 60px;
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 30px;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);

    ul {
      padding:0;

      li {
        min-height: 60px;
        padding-left: 56px;
        padding-right: 38px;
        color: #261A16;

        span {
          display: inline-block;
          font-size: 18px;
          line-height: 30px;
          vertical-align: middle;
          padding: 15px 30px;
          padding-left: 0;
          letter-spacing: 0.9px;
        }

        .name {
          font-weight: bold;
          width: 20%;

        }

        .text {
          height: 100%;
          width: calc(75% - 7px);
          padding: 14px 0 14px 46px;
          border-left: 1px solid #F3F3F3;
        }

        &:nth-child(even) {
          background: #fafafa;
        }
         &:last-child{
             .text{
               padding-bottom: 26px;
             }
             .name{
               padding-bottom: 26px;
             }
          }
          &:first-child{
            .text{
              padding-top: 26px;
            }
            .name{
              padding-top: 26px;
            }
           }
      }
    }
  }

}


.donor-roster {
  width: 100%;
  max-width: 1375px;
  height: auto;
  margin: auto;
/*  padding-bottom: 220px;
  padding-top: 380px;*/

  padding: 280px 20px 220px;
  .donor-swiper {
    width: 100%;
    height: auto;
    position: relative;

    .swiper-container {
      padding-top: 41px;
      padding-bottom: 40px;
    }

    .swiper-slide {
      width: 25%;
      transition: transform .3s ease-in-out;
      transform: translateY(41px);
      &.swiper-slide-active {
        transform: translateY(0);
      }

      &.swiper-slide-next {
        & + .swiper-slide {
          & + .swiper-slide {
            transform: translateY(0);
          }
        }
      }

      .img-box {
        position: relative;

        .img {
          width: 90%;
          border-radius: 50%;
          border: 5px solid #fff;
          position: relative;
          background: #fff;
          img {
            width: 100%;
            height: 100%;
            background-size: 100%;
            border-radius: 50%;
          }
        }

        .number {
          height: 63px;
          line-height: 63px;
          width: 64px;
          border-radius: 50%;
          background-color: #FFFFFF;
          color: #D00717;
          font-size: 22px;
          font-style: italic;
          font-weight: 900;
          text-align: center;
          position: absolute;
          right: -6%;
          bottom: 2%;
          border-radius: 50%;
          border: 3px solid #fff;
        }

        .text {
          padding-top: 18px;

          p {
            color: #FFFFFF;
            font-size: 18px;
            text-align: center;
            letter-spacing: 1px;
          }
        }
      }
    }


    .donor-conten-90 {
      width: 88%;
      margin: auto;
    }
  }
}
@media (max-width:1760px){
  .personnel-box,.set-All .set-conten,.set-All .donation-box .donation-text,.news-all{
    margin: auto;
  }
}

@media (max-width:1560px){


  .set-All {
      .set-conten{
          max-width:90%;
          .set-purpose-box{
            margin: 0 50px;
          .text{
            right: 8%;
            padding: 39px 75px 34px 75px;
            font-size: 18px;
          }
          .img{
            max-width: 80%;
            height: 516px;
          }
        }
      }
      .donation-box .donation-text{
        margin: 0 50px;
      }
  }
  .personnel-box{
    margin:0 50px;
  }

}


@media (max-width: 1080px) {
  .btnButton {
    margin: auto;
  }
  .swiper-slide-active,.swiper-slide-duplicate-prev {
    transform: translateY(0) !important;
  }
  .set-All .set-conten {
    width: 100%;
    max-width: 100%;
    padding: 0 20px;

    .set-purpose-box {
      height: auto;
      width: 100%;
      border-radius: 30px;
      background-color: #FFFFFF;
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);
      position: inherit;
      padding: 36px 22px;
      margin:0;
      margin-top:20px;
      .img {
        max-width: 100%;
        height: auto;

        img {
          width: 100%;
        }
      }

      .text {
        max-width: 100%;
        padding: 0;
        position: inherit;
        bottom: 0;
        right: 0;
        font-size: 15px;
        margin-top: 15px;
        border-radius: 0;
        line-height: 28px;
        box-shadow: none;
      }

    }

  }

  .set-All .set-banner {
    max-height: inherit;
  }

  .titleBox2 {
    margin-bottom: 0;
  }
  .text-right {
    text-align: center !important;
  }
  .set-All .donation-box {
    margin-top: 0;
    background: #D00717 url(../assets/images/donationBgM.png) no-repeat center top;
    background-size: 100%;
    position: relative;
    padding-bottom: 480px;

    .donation-text {
      max-width: 100%;
      padding-top: 80px;
      padding-bottom: 0;
      margin: 0;
    }

    .donation-text-conten {
      width: 100%;
      padding: 0 20px;
      /*background:#D00717;*/
      .donation-text-box {
        padding: 30px 18px 44px;
        .date {
          font-size: 18px;
          font-weight: 900;
        }
      }

      .subtitle {
        font-size: 18px;
      }
      .account{
        border-bottom:0;
          p {
            font-size: 15px;
            letter-spacing: 0.75px;
            margin-bottom:35px;
            line-height: 28px;
              label{
                display: block;
              }
             &:last-child{
                padding-bottom: 0;
              }
          }

      }
      .send{
        padding-top: 0;
         padding-bottom:44px;
        p{
          padding-bottom:10px;
        }
      }
    }

    .donation-img {
      width: 100%;
      margin-top: 38px;
      margin-bottom:26px;

      &.mobile_hide {
        display: none;
      }

      &.pc_hide {
        display: block;
      }

      img {
        margin-left: 0;
      }
    }
  }
  .news-all {
    width: 100%;
    margin-top: 0;
    position: absolute;
    bottom: -300px;
    padding: 0 20px;
   /* bottom: -210px;*/
     .news-text{
       padding: 60px 14px;
     }

  }
.news-all .news-text ul li .text .conten{
  width: 73%;
}
  .setNews-swiper {
    padding: 0;
    margin-top: 38px;

  }

  .titleBox {
    margin:0;
  }
  .service-rules {
    width: 100%;
   /* padding: 256px 0 0;*/
    padding: 356px 0 0;
    .service-swiper {
      margin-top: 0;

      .swiper-slide {
        padding-top: 70px;
        padding-bottom: 43px;
        -webkit-transform: translateY(0) !important;
        transform: translateY(0) !important;
        .title {
          font-size: 40px;
          top: -29px;
        }

        .text {
          font-size: 15px;
          letter-spacing: 0.75px;
          line-height: 30px;
        }

        .slide-box {
          min-height: 150px;
          height: auto;
          padding: 27px 37px;
        }
      }
    }
    .swiper-button-prev,.swiper-button-next{
      top:55%;
    }
    .swiper-button-prev{
      left: 10px;
    }
    .swiper-button-next{
      right:10px;
    }
  }

  .setAboutUs {
    margin-top: 0;
    background: #FAFAFA;

    .personnel-box {
      width: 100%;
      padding: 0 20px;

    }
  }
  .donor-roster {
    width: 100%;
    background: #D00717 url(../assets/images/Visit-recordBG.png) no-repeat center top;
    background-size: 100%;
    padding:38px 0 80px;

    .donor-swiper{
     padding-top:30px;
        .swiper-slide {
        &.swiper-slide-active {
           transform: translateY(0);
         }

        &.swiper-slide-next {
        & + .swiper-slide {
        & + .swiper-slide {
              transform: translateY(0);
            }
        }
        }
        .img-box .img {
          width: 230px;
          height: 234px;
          margin: auto;
        }
        }

}
    .number {
      display: none;
    }
  }
  .personnel-box {
    width: 100%;
    padding: 0 20px;
    position: inherit;
    left: 0;
    top: -10px;
    margin: 0;
    .personnel-list-name ul {
      padding-top: 0;

      li {
        padding: 0;
        .name{
          width: 25%;
        }
        span {
          padding: 0;
          font-size: 15px;
          padding: 30px 10px;
          vertical-align: top;
        }

        .text {
          padding: 30px 10px;
        }
      }
    }
  }

  .service-rules {
    .subtitle-2 {
      font-size: 15px;
      margin-top: 28px;
      letter-spacing: 0.75px;
    }
  }

  .personnel-all {
    margin-top: 0;
  }
  .donor-roster {
    .donor-swiper {
      .swiper-container{
        padding: 0;
      }
      .swiper-slide{
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }
  }
}
@media (max-width: 568px) {
  .show_768{
    display: block;
  }
  .hide_768{
    display: none;
  }
  .setNews-all {
   .swiper-slide {
    display: block;

     .swiper-box {
       width: 90%;
       margin: auto;
       height: 540px;
       overflow: hidden;
     }

     .img {
         width: 100%;
         height: auto;
         border-top-right-radius: 30px;
         border-top-left-radius: 30px;
        img {
          border-top-right-radius: 30px;
          border-top-left-radius: 30px;
        }
     }
         .text {
            width: 100%;
            height: 280px;
            border-bottom-left-radius: 30px;
            border-bottom-right-radius: 30px;
            background-color: #FFFFFF;
            padding: 20px;

                h3 {
                  font-size: 16px;
                  font-weight: 500;
                  text-align: left;
                  padding-bottom: 4px;
                  color: #000;
                }

                p {
                  font-size: 15px;
                  letter-spacing: 0.83px;
                  line-height: 32px;
                  text-align: left;
                  color: #000;
                  height: 100px;
                  overflow: auto;
             }

            .more {
              display: none;
           }
        }
    }
  }

  .service-rules {
     padding: 256px 0 0;
  }
.news-all{
  padding: 0;
  bottom: -200px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/setAim.vue